import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/icons/fast-forward.svg';
import _imports_1 from '@/assets/mintview/comic/scroll.svg';
import _imports_2 from '@/assets/mintview/comic/1.jpg';
import _imports_3 from '@/assets/mintview/comic/2.jpg';
const _hoisted_1 = {
  class: "comic-page-container"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Skip",
  class: "icon"
}), /*#__PURE__*/_createTextVNode(" SKIP TO MINT ")], -1);
const _hoisted_3 = {
  id: "comic-container-wrapper",
  class: "comic-container-wrapper scroll"
};
const _hoisted_4 = {
  key: 0,
  class: "landing comic-container"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Scroll",
  class: "scroll"
}, null, -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Landing comic page",
  class: "comic"
}, null, -1);
const _hoisted_7 = {
  class: "action-buttons-container"
};
const _hoisted_8 = {
  key: 1,
  class: "think-again comic-container"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Scroll",
  class: "scroll"
}, null, -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Think again comic page",
  class: "comic"
}, null, -1);
const _hoisted_11 = {
  class: "action-buttons-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    text: true,
    onClick: _ctx.close,
    class: "skip-button button"
  }, {
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("div", _hoisted_3, [!_ctx.displayThinkAgainComic ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
    text: true,
    onClick: _ctx.close,
    class: "yes-button action-button button"
  }, {
    default: _withCtx(() => [_createTextVNode("YES")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    text: true,
    onClick: _cache[0] || (_cache[0] = () => {
      _ctx.displayThinkAgainComic = true;
      _ctx.scrollToTopOfWrapper();
    }),
    class: "no-button action-button button"
  }, {
    default: _withCtx(() => [_createTextVNode("NO")]),
    _: 1
  })])])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
    text: true,
    onClick: _cache[1] || (_cache[1] = () => {
      _ctx.displayThinkAgainComic = false;
      _ctx.scrollToTopOfWrapper();
    }),
    class: "think-again-button action-button button"
  }, {
    default: _withCtx(() => [_createTextVNode("THINK AGAIN")]),
    _: 1
  })])]))])]);
}